import { useQuery } from '@tanstack/react-query'
import * as endPoints from '@/endpoints'
import useAuth from '@/hooks/useAuth'
import axios from '@/lib/axios'

const useLocations = ({ enabled = true } = {}) => {
    const { activeOrg } = useAuth()
    const activeOrgId = activeOrg?.id

    return useQuery({
        queryKey: ['locations', activeOrgId],
        queryFn: () =>
            axios.get(endPoints.LOCATIONS).then((response) => response.data),
        enabled: Boolean(activeOrgId) && enabled,
        staleTime: 1000 * 60 * 2, // 5 minutes
        placeholderData: () => []
    })
}

export default useLocations
